import { registerDevMenuItems } from "expo-dev-menu"
import { router } from "expo-router"
import { Platform } from "react-native"
import { $creditScoreRepair } from "@/screens/loans/components/CreditRepairWidget"
import { $orchardWidget } from "@/screens/loans/components/OrchardWidget"

if (Platform.OS !== "web") {
  void registerDevMenuItems([
    {
      name: "Go to loans/products",
      callback: () => {
        router.push("/loans/products")
      },
    },
    {
      name: "Clear Affiliate Marketing Widgets",
      callback: () => {
        $creditScoreRepair.set("true")
        $orchardWidget.set("true")
      },
    },
  ])
}
